import CreditCard from '../src/CreditCard/index.tsx';
export default CreditCard;
